var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpiAr211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5137 11.4398L29.3329 7.95583L27.5238 4.35156L25.5137 11.4398Z",
    fill: "#097939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2275 11.4398L28.0467 7.95583L26.2377 4.35156L24.2275 11.4398Z",
    fill: "#ED752E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97603 4.39164L4.36803 10.1183L10.0766 10.1583L11.6446 4.39164H13.0918L11.2118 11.0956C11.1398 11.3516 10.8656 11.5596 10.5998 11.5596H3.28269C2.83896 11.5596 2.57603 11.213 2.69603 10.7863L4.48909 4.39164H5.97603ZM23.6246 4.35164H25.0718L23.0616 11.5596H21.5736L23.6246 4.35164ZM13.2528 7.35484L20.4891 7.31484L20.9718 5.79298H13.6144L14.0566 4.39138L21.8966 4.31938C22.3846 4.31484 22.6752 4.69271 22.5467 5.16391L21.808 7.86364C21.6792 8.33458 21.1787 8.71618 20.6907 8.71618H14.2176L13.4544 11.6796H12.0464L13.2528 7.35484Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiAr211);
export default __webpack_public_path__ + "static/media/upi-ar21-1.d0fb04cdea57c2890674a41a3e3c4e67.svg";
export { ForwardRef as ReactComponent };